import useGetSpentPointsHistory from './useGetSpentPointsHistory'
export default useGetSpentPointsHistory
